import { useContext } from 'react'

import {
  DatePicker,
  DatePickerProps,
  Text,
} from '@hhgtech/hhg-components/mantine'
import { Box, Flex, Stack, rem, useMantineTheme } from '@mantine/core'
import dayjs from 'dayjs'
import { useIntl } from 'react-intl'

import { useIsMobile } from 'hooks/useIsMobile'
import {
  API_DATE_FORMAT,
  DISPLAY_DATE_FORMAT,
  SSO_URL,
} from 'interfaces/constants'
import { AppContext } from 'state/appContext'
import { ISO_FORMAT } from '@hhgtech/hhg-components/constants'
import { useRouterExtend } from 'hooks/useRouterExtend'

type Props = {
  minAge?: number
  maxAge?: number
  disableSSOAge?: boolean
} & DatePickerProps

const AgeInput = ({
  minAge = 14,
  maxAge = 100,
  disableSSOAge,
  ...rest
}: Props) => {
  const {
    state: { userInfo },
  } = useContext(AppContext)
  const { locale } = useRouterExtend()
  const { formatMessage: f } = useIntl()
  const theme = useMantineTheme()
  const isMobile = useIsMobile()
  return (
    <Box
      sx={{
        'input[data-disabled="true"]': {
          background: '#ffffff',
          border: 0,
          opacity: 1,
          color: 'inherit',
          paddingLeft: 0,
          '&[data-no-disable-padding="true"]': {
            height: 'auto',
          },
        },
      }}
    >
      <DatePicker
        {...rest}
        maxDate={dayjs()
          .set('year', dayjs().get('year') - minAge)
          .toDate()}
        minDate={dayjs()
          .set('year', dayjs().get('year') - maxAge)
          .toDate()}
        disabled={!disableSSOAge && Boolean(userInfo?.birthday)}
        data-no-disable-padding="true"
        label={
          <Text as="label" size="s4">
            {f({
              id: 'common.form.label.yourBirthday',
            })}
          </Text>
        }
        sx={{
          ...(!disableSSOAge && {
            display: Boolean(userInfo?.birthday) ? 'none' : 'initial',
          }),
        }}
        dropdownType={isMobile ? 'modal' : 'popover'}
        modalProps={isMobile ? { zIndex: 306 } : undefined}
      />
      {!disableSSOAge && Boolean(userInfo?.birthday) && (
        <Stack spacing={0}>
          <Text as="label" size="s4">
            {f({
              id: 'common.form.label.yourBirthday',
            })}
          </Text>
          <a href={`${SSO_URL}user/profile/`}>
            <Flex
              sx={{
                gap: rem(12),
              }}
            >
              <Text size="p2">
                {dayjs(userInfo?.birthday, API_DATE_FORMAT).format(
                  ISO_FORMAT[locale]?.dateFormat || DISPLAY_DATE_FORMAT,
                ) || ''}
              </Text>
              <Flex
                align={'center'}
                gap={rem(2)}
                sx={{
                  borderBottom: `1px solid ${theme.fn.primaryColor()}`,
                  [theme.fn.smallerThan('sm')]: {
                    marginBottom: rem(5),
                  },
                }}
              >
                <Text
                  size={isMobile ? 'p3' : 'p4'}
                  color={theme.fn.primaryColor()}
                >
                  {f({
                    id: 'tools.editInProfile',
                    defaultMessage: 'Edit in profile',
                  })}
                </Text>
              </Flex>
            </Flex>
          </a>
        </Stack>
      )}
    </Box>
  )
}

export { AgeInput }
